<template>
    <div style="min-width:75%;">

        <h1 class='text-secondary mb-5'>{{ section.name }}</h1>


        <div class="" v-for="(job, jobIdx) in datas.career">

            <div class="d-flex flex-column flex-lg-row">
                <div class="text-center" style="min-width:200px;">
                    <img :src="job.organization.logo" style="width:50px; height:50px;" />
                </div>
                <div class="flex-grow-1">
                    <p class="">
                        <b class='text-primary m-0 p-0'>{{ job.organization.name }}</b>
                        <br />
                        <span class='text-muted m-0 p-0' style="">
                            {{ job.organization.type != null ? [job.organization.type, job.organization.location].join(' - ') : job.organization.location }}
                        </span>
                    </p>
                </div>
            </div>

            <div v-for="mission in job.missions" class="d-flex flex-column flex-lg-row mb-1">

                <div class="text-left text-lg-center" style="min-width:200px;">
                    <p style="font-size:1rem;line-height:1.5rem;" class="text-primary">
                        {{ showPeriod(mission.from, mission.to) }}
                    </p>
                </div>

                <div style="">
                    <p style="font-size:1rem;line-height:1.5rem;text-align:justify;" class="m-0">
                        <b class="text-success">{{ mission.label }} : </b>
                        <span class="text-secondary" v-html="mission.description"></span>
                    </p>
                    <p v-if="mission.stack != null" class='text-muted ps-1' style="font-size:0.9rem;line-height:1.5rem;">
                        <i class="bi bi-stack me-1"></i> {{ mission.stack.join(', ') }}
                    </p>
                </div>
            </div>

            <hr v-if="jobIdx < datas.career.length - 1" style="margin-left:200px;margin-right:25%;" />

        </div>

    </div>
</template>

<script>
export default {
    name: 'SectionCareer',
    props : {
        section : { type : Object, required : true }
    },
    data : function() {
        return {
            detail : true,
        }
    },
    mounted : function() {

    },
    methods : {
        showPeriod : function(from, to) {
            let fromDate = this.$dayjs([from[0], from[1], 1]);
            let toDate = to == null ? null : this.$dayjs([to[0], to[1], 1]);

            if (toDate != null)
            {
                return fromDate.format('YYYY') + " - " + toDate.format('YYYY') + " · " +fromDate.from(toDate, true);
            }
            else
            {
                return "Depuis " + fromDate.format('YYYY') + " · " + fromDate.fromNow(true);
            }
        }
    }
}
</script>

<style scoped>
.detailed:not(:last-child) {
    border-bottom:1px solid #DDD;
}

.logo img {
    width : 48px;
    height : 48px;
}

.organization .name h3 {
    margin-bottom : 0px;
}

h3 {
    font-size:1.5rem;
}
</style>
